import { WithdrawalApiService } from "@api-services/withdrawal/WithdrawalApiService";
import LookupApiService from "@api-services/LookupApiService";
import { BaseLookupDto } from "@api-types/lookups/BaseLookupDto";
import {
	WithdrawalDataDto,
	WithdrawalResponseDto,
	UsedPaymentMethodDto,
	WithdrawalInitRequestDataDto,
} from "@api-types/withdrawal";
import { PaymentRequestFilter } from "@data-types/withdrawal";
import { FindResultDto } from "@api-types/FindResultDto";
import { UserPaymentTransactionsApiService } from "@api-services/user-payment-transactions/UserPaymentTransactionsApiService";
import { PaymentManagerApiService } from "@api-services/withdrawal/PaymentManagerApiService";
import { CancelWithdrawalErrorResponseDto } from "@api-types/withdrawal";

export class WithdrawalService {
	static async getAvailableMethods(
		bettingAccountTypeId: string
	): Promise<WithdrawalDataDto> {
		return await WithdrawalApiService.getAvailableMethods(
			bettingAccountTypeId
		);
	}

	static async initializeNewWithdrawalProcess(
		data: WithdrawalInitRequestDataDto
	): Promise<WithdrawalDataDto> {
		return await WithdrawalApiService.initializeNewWithdrawalProcess(data);
	}

	static async getUserPaymentMethods(): Promise<UsedPaymentMethodDto[]> {
		const isDeposit = false;
		return await LookupApiService.getUserPaymentMethods(isDeposit);
	}

	static async getTransactionStatuses(): Promise<
		FindResultDto<BaseLookupDto>
	> {
		return await LookupApiService.getTransactionStatuses();
	}

	static async getWithdrawalData(
		bodyData: PaymentRequestFilter
	): Promise<WithdrawalResponseDto> {
		return await UserPaymentTransactionsApiService.getWithdrawalData(
			bodyData
		);
	}

	static async cancelWithdrawalTransaction(
		transactionId: string
	): Promise<void> {
		const response: Response =
			await PaymentManagerApiService.cancelWithdrawalTransaction(
				transactionId
			);

		if (response.ok) {
			return;
		}

		if (response.status === 400) {
			const data: CancelWithdrawalErrorResponseDto =
				await response.json();
			throw {
				statusCode: response.status,
				data,
			};
		}

		throw {
			statusCode: response.status,
		};
	}
}
